import type { HelpTopicPair } from "../types";

const topic: HelpTopicPair = {
  th: {
    id: "branding",
    title: "แบรนด์ (หน้าตาหน้าเข้าสู่ระบบ)",
    summary:
      "กำหนดหน้าตาส่วนกลางของหน้าเข้าสู่ระบบ สมัครสมาชิก ยืนยันสองขั้นตอน และหน้าบัญชีของฉัน: ชื่อผลิตภัณฑ์ โลโก้ สีหลัก อีเมลฝ่ายสนับสนุน และข้อความต้อนรับ",
    access:
      "เปิดดูได้เมื่อมีสิทธิ์ settings:read (owner, admin, auditor) การแก้ไขและปุ่ม “บันทึก” ต้องมีสิทธิ์ settings:write (owner, admin) ผู้ที่ไม่มีสิทธิ์จะเห็นฟอร์มเป็นแบบอ่านอย่างเดียว",
    shot: { file: "branding-page.png", caption: "หน้า การตั้งค่า → แบรนด์" },
    sections: [
      {
        id: "where-used",
        heading: "ค่าบนหน้านี้ใช้ที่ไหน",
        body: [
          "หน้านี้เป็น “แบรนด์ส่วนกลาง” ใช้กับทุกหน้าของระบบเข้าสู่ระบบกลาง ได้แก่ หน้าเข้าสู่ระบบ สมัครสมาชิก ยืนยันสองขั้นตอน ขอความยินยอม หน้า “ไม่มีสิทธิ์เข้าแอปนี้” และหน้าบัญชีของฉัน",
          "แต่ละแอปพลิเคชันตั้งโลโก้ สี และข้อความของตัวเองได้ (แท็บ “แบรนด์” ในหน้ารายละเอียด OAuth client) เมื่อผู้ใช้มาจากแอปนั้น ระบบจะใช้ค่าของแอปก่อน ช่องที่แอปไม่ได้ตั้งจะใช้ค่าจากหน้านี้",
          "หน้าที่เปิดจากลิงก์ในอีเมล (รีเซ็ตรหัสผ่าน ยืนยันอีเมล) หน้าบัญชีของฉัน และการเปิดหน้าเข้าสู่ระบบตรง ๆ จะใช้แบรนด์ส่วนกลางนี้เสมอ",
        ],
      },
      {
        id: "fields",
        heading: "ช่องในส่วน “แบรนด์”",
        fieldsTitle: "ช่องในฟอร์ม",
        fields: [
          {
            name: "ชื่อผลิตภัณฑ์",
            required: true,
            description:
              "ชื่อระบบที่แสดงข้างโลโก้และในชื่อแท็บของเบราว์เซอร์ เช่น “Pacred Account” ไม่เกิน 60 ตัวอักษร ห้ามว่าง",
          },
          {
            name: "URL โลโก้",
            description:
              "ที่อยู่รูปโลโก้แบบ HTTPS เช่น https://cdn.example.com/logo.svg เว้นว่าง = ใช้สัญลักษณ์เริ่มต้น (โล่ในสีหลัก) คู่กับชื่อผลิตภัณฑ์ แนะนำ SVG หรือ PNG พื้นโปร่งใส ซึ่งดูดีทั้งโหมดสว่างและโหมดมืด",
          },
          {
            name: "สีหลัก",
            description:
              "สีของปุ่ม ลิงก์ และองค์ประกอบเด่น เลือกจากตัวเลือกสี หรือพิมพ์รหัส #rrggbb (เช่น #009be5 ซึ่งเป็นค่าเริ่มต้น) ถ้ารูปแบบไม่ถูกต้องจะเห็นข้อความ #rrggbb สีแดงใต้ช่อง และบันทึกไม่ได้",
          },
          {
            name: "อีเมลฝ่ายสนับสนุน",
            description: "อีเมลติดต่อเมื่อผู้ใช้มีปัญหา เผยแพร่พร้อมข้อมูลแบรนด์ ไม่บังคับ",
          },
        ],
      },
      {
        id: "hero-text",
        heading: "ส่วน “ข้อความหน้าเข้าสู่ระบบ”",
        body: [
          "หัวข้อและข้อความที่แสดงฝั่งซ้ายของหน้าเข้าสู่ระบบบนจอใหญ่ (บนมือถือจะแสดงเฉพาะโลโก้และฟอร์ม) แยกภาษาไทยและอังกฤษ ผู้ใช้จะเห็นภาษาตามที่เลือกบนหน้าเข้าสู่ระบบ",
          "ถ้าเว้นว่าง ระบบจะใช้ข้อความเริ่มต้น ซึ่งแสดงเป็นตัวจางในช่องให้เห็นว่าผู้ใช้จะเห็นอะไร",
        ],
        fields: [
          {
            name: "หัวข้อ (ไทย) / หัวข้อ (อังกฤษ)",
            description: "ไม่เกิน 120 ตัวอักษร กด Enter เพื่อขึ้นบรรทัดใหม่",
          },
          {
            name: "ข้อความ (ไทย) / ข้อความ (อังกฤษ)",
            description: "ข้อความใต้หัวข้อ ไม่เกิน 500 ตัวอักษร แสดงเป็นข้อความธรรมดา (ไม่รองรับ HTML)",
          },
        ],
      },
      {
        id: "preview-contrast",
        heading: "ตัวอย่างและความคมชัดของสี",
        shot: { file: "branding-preview.png", caption: "ส่วน “ตัวอย่าง” ของหน้าเข้าสู่ระบบ" },
        body: [
          "ส่วน “ตัวอย่าง” แสดงหน้าเข้าสู่ระบบจำลองขนาดเล็ก (โลโก้/ชื่อ ช่องกรอก ลิงก์ “ลืมรหัสผ่าน?” และปุ่ม “เข้าสู่ระบบ”) อัปเดตทันทีขณะแก้ไข โดยใช้วิธีคำนวณสีเดียวกับหน้าเข้าสู่ระบบจริง",
          "ระบบปรับสีให้อ่านง่ายตามมาตรฐาน WCAG AA โดยอัตโนมัติ: ถ้าสีหลักอ่อนเกินไปสำหรับตัวอักษร ลิงก์จะใช้เฉดที่เข้มขึ้น ปุ่มจะใช้ตัวอักษรสีขาวหรือสีเข้มแล้วแต่ว่าแบบไหนอ่านชัดกว่า (เช่น สีเหลืองจะได้ตัวอักษรสีเข้ม) และในโหมดมืดลิงก์จะใช้เฉดที่สว่างขึ้น ดังนั้นสีที่เห็นบนปุ่มอาจเข้มกว่าสีที่เลือกเล็กน้อย — เป็นเรื่องปกติ",
        ],
        tips: ["หลังบันทึก เปิดหน้าเข้าสู่ระบบจริงในหน้าต่างไม่ระบุตัวตน (incognito) เพื่อตรวจผลลัพธ์"],
      },
      {
        id: "save",
        heading: "บันทึกการเปลี่ยนแปลง",
        steps: [
          "แก้ไขช่องที่ต้องการ แล้วดูผลในส่วน “ตัวอย่าง”",
          "กด “บันทึก” ที่มุมขวาล่าง (ปุ่มจะกดไม่ได้ถ้าชื่อผลิตภัณฑ์ว่างหรือรหัสสีไม่ถูกต้อง)",
          "ผู้ใช้จะเห็นหน้าตาใหม่เมื่อเปิดหน้าเข้าสู่ระบบครั้งถัดไป",
        ],
        warnings: [
          "ถ้ามีผู้ดูแลคนอื่นบันทึกการตั้งค่านี้ก่อนคุณ จะเห็นข้อความ “การตั้งค่าถูกแก้ไขโดยผู้อื่นแล้ว — โหลดใหม่เพื่อดูเวอร์ชันล่าสุด” ให้กดโหลดใหม่แล้วแก้ไขอีกครั้ง เพื่อไม่ให้ทับงานของผู้อื่น",
        ],
        tips: [
          "การเปลี่ยนแบรนด์ไม่ทำให้ใครถูกออกจากระบบ และถูกบันทึกในบันทึกการใช้งานเป็น settings.updated (key: branding)",
        ],
      },
    ],
    related: ["client-detail", "sign-in-method", "audit-logs"],
  },
  en: {
    id: "branding",
    title: "Branding (sign-in page look)",
    summary:
      "Sets the global look of the sign-in, sign-up, two-step verification and My account pages: product name, logo, primary color, support email and welcome text.",
    access:
      "Viewing needs settings:read (owner, admin, auditor). Editing and “Save” need settings:write (owner, admin); without it the form is read-only.",
    shot: { file: "branding-page.png", caption: "Settings → Branding" },
    sections: [
      {
        id: "where-used",
        heading: "Where these values are used",
        body: [
          "This is the global branding, used on every page of the central sign-in: sign-in, sign-up, two-step verification, consent, “no access to this application” and My account.",
          "Each application can set its own logo, color and text (the “Branding” tab of the OAuth client detail page). When people arrive from that application its values win; anything it leaves empty comes from this page.",
          "Pages opened from email links (password reset, email verification), My account, and a direct visit to the sign-in page always use this global branding.",
        ],
      },
      {
        id: "fields",
        heading: "Fields in the “Branding” section",
        fieldsTitle: "Fields in the form",
        fields: [
          {
            name: "Product name",
            required: true,
            description:
              "Shown next to the logo and in the browser tab title, e.g. “Pacred Account”. Up to 60 characters; cannot be empty.",
          },
          {
            name: "Logo URL",
            description:
              "An HTTPS image, e.g. https://cdn.example.com/logo.svg. Empty = the default mark (a shield in the primary color) with the product name. SVG or transparent PNG looks best in light and dark mode.",
          },
          {
            name: "Primary color",
            description:
              "Color of buttons, links and highlights. Use the color picker or type #rrggbb (the default is #009be5). An invalid value shows a red #rrggbb under the field and cannot be saved.",
          },
          {
            name: "Support email",
            description: "Where users can get help; published with the branding information. Optional.",
          },
        ],
      },
      {
        id: "hero-text",
        heading: "The “Sign-in page text” section",
        body: [
          "The headline and text on the left of the sign-in pages on large screens (phones show only the logo and the form), in Thai and English; users see the language they chose on the sign-in page.",
          "Leave a field empty to use the built-in text, which is shown greyed out in the field so you can see what users will get.",
        ],
        fields: [
          {
            name: "Headline (Thai) / Headline (English)",
            description: "Up to 120 characters; press Enter for a line break.",
          },
          {
            name: "Text (Thai) / Text (English)",
            description: "Text under the headline, up to 500 characters; plain text (no HTML).",
          },
        ],
      },
      {
        id: "preview-contrast",
        heading: "Preview and color contrast",
        shot: { file: "branding-preview.png", caption: "The “Preview” of the sign-in page" },
        body: [
          "“Preview” shows a small mock sign-in form (logo / name, an input, the “Forgot password?” link and the “Sign in” button) that updates as you type, using the same color calculation as the real sign-in pages.",
          "Colors are adjusted automatically to stay readable (WCAG AA): if the primary color is too light for text, links use a darker shade; buttons get white or dark text, whichever is clearer (yellow gets dark text); in dark mode links use a lighter shade. The button may therefore look slightly darker than the color you picked — that is expected.",
        ],
        tips: [
          "After saving, open the real sign-in page in a private (incognito) window to check the result.",
        ],
      },
      {
        id: "save",
        heading: "Saving changes",
        steps: [
          "Edit the fields and watch the “Preview”.",
          "Click “Save” at the bottom right (disabled while the product name is empty or the color is invalid).",
          "Users see the new look the next time they open a sign-in page.",
        ],
        warnings: [
          "If another administrator saved this setting before you, you see “Settings were changed by someone else — reload to see the latest version.” Reload and make your change again so you do not overwrite their work.",
        ],
        tips: [
          "Branding changes sign nobody out and are recorded in the audit log as settings.updated (key: branding).",
        ],
      },
    ],
    related: ["client-detail", "sign-in-method", "audit-logs"],
  },
};

export default topic;
